import * as React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { EntityType, OrganisationType, TradingEntity } from 'api'
import { ComboboxField, ComboboxProps } from 'view/components/options'
import { COUNTERPARTY_COLOURS } from 'view/routes/staging/SendRFQPanel/rfqPanelStyles'
import { TradingEntityHelper } from 'model'
import { createEntityGetterSelector } from 'selectors/entitySelectors'
import { createOrganisationTypeTradingEntityListSelector } from 'selectors/tradingEntitySelectors'
import { Locale, Translation } from 'locale'

type TradingRelationshipTradingEntityComboboxProps = OwnProps & StateProps

interface OwnProps extends Omit<ComboboxProps<TradingEntity, string>, 'optionKeys'> {
  organisationId: string | null
  organisationType: OrganisationType
  existingRelationshipsTradingEntityIds?: string[]
  validationField: string
}

interface StateProps {
  tradingEntityIdList: string[]
  getTradingEntity: (tradingEntityId: string) => TradingEntity | null
}

interface DispatchProps {}

const organisationIdSelector = (_: {}, props: TradingRelationshipTradingEntityComboboxProps) => props.organisationId
const organisationTypeTypeSelector = (_: {}, props: TradingRelationshipTradingEntityComboboxProps) => props.organisationType

const mapStateToProps = createStructuredSelector({
  tradingEntityIdList: createOrganisationTypeTradingEntityListSelector(organisationIdSelector, organisationTypeTypeSelector),
  getTradingEntity: createEntityGetterSelector(EntityType.TRADING_ENTITY)
})

const getFilteredTradingEntityIdList = (tradingEntityIdList: string[], existingRelationshipsTradingEntityIds?: string[]) => {
  if (!existingRelationshipsTradingEntityIds) {
    return tradingEntityIdList
  }

  const toRemove = new Set([...existingRelationshipsTradingEntityIds])
  return tradingEntityIdList.filter(tradingEntityId => !toRemove.has(tradingEntityId))
}

const TradingRelationshipTradingEntityComboboxComponent: React.FC<TradingRelationshipTradingEntityComboboxProps> = props => {
  const { tradingEntityIdList, getTradingEntity, existingRelationshipsTradingEntityIds, validationIssues } = props

  return (
    <ComboboxField
      optionKeys={getFilteredTradingEntityIdList(tradingEntityIdList, existingRelationshipsTradingEntityIds)}
      getOption={getTradingEntity}
      getOptionText={TradingEntityHelper.getName}
      noItemsText={Locale.translate(Translation.SC_N_TRADING_ENTITIES, { count: 0 })}
      placeholder={Locale.translate(Translation.SC_SELECT_TRADING_ENTITY)}
      optionColorPalette={COUNTERPARTY_COLOURS}
      label={Locale.translate(Translation.TC_TRADING_ENTITY)}
      validationIssues={validationIssues}
      {...props}
    />
  )
}

export const TradingRelationshipTradingEntityCombobox = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, null, null, {
  forwardRef: true
})(TradingRelationshipTradingEntityComboboxComponent)
